import React from "react";
import Customer from "../../components/Customer";
import { compose, setDisplayName, withHandlers } from "recompose";
import WithFetchCustomer from "../WithFetchCustomer/index";
import WithFetchScooters from "../WithFetchScooters/index";
import { Row, Col } from "reactstrap";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faTrash, faPlus, faEdit } from "@fortawesome/fontawesome-free-solid";
import { connect } from "react-redux";
import ScooterList from "../../components/ScooterList";
import { actions } from "../../modules/scooters";
import Button from "../../components/CustomButton";
import ScooterButton from "../../components/ScooterButton";
import CustomerButton from "../../components/CustomerButton"

const withScooterState = connect(
  state => ({}),
  {
    deleteScooter: actions.deleteScooter,
    createScooterSync: actions.createScooterSync,
    updateScooterSync: actions.updateScooterSync
  }
);

const withScooterHandlers = withHandlers({
  onSuccessSubmitCreate: ({ createScooterSync }) => scooter => {
    createScooterSync(scooter);
  },
  onDeleteScooter: ({
    currentDealer,
    currentCustomer,
    deleteScooter
  }) => scooter => () => {
    window.confirm("Do you really wish to delete this scooter") &&
      deleteScooter({
        dealer_id: currentDealer.id,
        customer_id: currentCustomer.id,
        scooter_id: scooter.id
      });
  }
});

const CustomerScooters = compose(
  setDisplayName("CustomerScooters"),
  WithFetchScooters,
  withScooterState,
  withScooterHandlers
)(
  ({
    onSuccessSubmitCreate,
    scooters,
    setCurrentScooter,
    onDeleteScooter,
    updateScooterSync
  }) => (
    <div>
      <div className="row justify-content-between align-items-center">
        <div className="col-auto">
          <h4 className="title">Customer Scooters</h4>
        </div>
        <div className="col-auto">
          <ScooterButton
            formAction="create"
            onSubmitSuccess={onSuccessSubmitCreate}
          >
            {({ onClick }) => (
              <h4 className="text-info selectable" onClick={onClick}>
                Create Scooter <FontAwesomeIcon icon={faPlus} />
              </h4>
            )}
          </ScooterButton>
        </div>
      </div>
      <br />
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <ScooterList scooters={scooters || []}>
            {({ scooter }) => (
              <div>
                <ScooterButton
                  formAction="update"
                  onSubmitSuccess={updateScooterSync}
                >
                  {({ onClick }) => (
                    <Button
                      color="info"
                      simple
                      onClick={ev => {
                        setCurrentScooter(scooter);
                        onClick(ev);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </Button>
                  )}
                </ScooterButton>
                <Button color="info" simple onClick={onDeleteScooter(scooter)}>
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </div>
            )}
          </ScooterList>
        </Col>
      </Row>
    </div>
  )
);

const CustomerShow = ({ currentCustomer }) => {
  return (
    <div className="content">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h4 className="title">Customer Details</h4>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Customer customer={currentCustomer} />
        </Col>
      </Row>
      <br />
      <CustomerScooters />
      <Row>
        <Col md={2}>
          <CustomerButton actionType="update" />
        </Col>
      </Row>
    </div>
  );
};

export default compose(
  setDisplayName("CustomerShow"),
  WithFetchCustomer
)(CustomerShow);
